export enum ContentTypeEnum {
  READING = 'READING',
  VIDEO = 'VIDEO',
  QUIZ = 'QUIZ',
  ASSIGNMENT = 'ASSIGNMENT',
  LiveSession = 'LiveSession',
}
